import { render } from "./ShowReceipt.vue?vue&type=template&id=2096422f&scoped=true"
import script from "./ShowReceipt.vue?vue&type=script&lang=js"
export * from "./ShowReceipt.vue?vue&type=script&lang=js"

import "./ShowReceipt.vue?vue&type=style&index=0&id=2096422f&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2096422f"]])

export default __exports__